import { DocumentVersionSuggestions, useSuggestionDecisions } from '@dataroom/shared';
import { useResolveVersionSuggestions, useVersionSuggestions } from '@/api/hooks';

interface VersionSuggestionsPanelProps {
  roomId: string;
  /** The document whose review panel this sits in: only its suggestions show. */
  documentId: string;
  /** Open a document's review panel. */
  onOpenDocument?: (documentId: string) => void;
}

/**
 * The "Possible new version" suggestions (ADR-0031) involving ONE document, in
 * its review panel: the same compact rows as the data room's list, with Merge /
 * Keep separate. Renders nothing while loading, on an error, or when there is
 * none. The room-wide list (with bulk actions) is VersionSuggestionsReview.
 */
export function VersionSuggestionsPanel({
  roomId,
  documentId,
  onOpenDocument,
}: VersionSuggestionsPanelProps) {
  const suggestions = useVersionSuggestions(roomId);
  const resolve = useResolveVersionSuggestions(roomId);
  const decisions = useSuggestionDecisions(resolve.mutateAsync);
  return (
    <DocumentVersionSuggestions
      suggestions={suggestions.data}
      documentId={documentId}
      decisions={decisions}
      onOpenDocument={onOpenDocument}
    />
  );
}
